import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

interface GalleryModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function GalleryModal({
  isOpen,
  onClose,
  children,
}: GalleryModalProps) {
  if (typeof document === "undefined") return null;
  return isOpen
    ? createPortal(
        <div
          className={`modal modal-container modal-box transition-all duration-300 shadow-custom-6 w-screen h-screen p-[0] md:p-[20px] lg:p-[24px] bg-white fixed top-0 left-0 z-[5]`}
        >
          <button
            onClick={onClose}
            className="modal_close flex items-center justify-center gap-[8px] absolute top-[24px] max-lg:right-[20px] lg:left-[20px] z-[1] cursor-pointer"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="stroke-primary-400"
                d="M1 13L13 1M1 1L13 13"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="small font-semibold text-primary-400">Close</span>
          </button>
          <div className="review-modal-container flex flex-col gap-[16px] max-lg:justify-center h-screen lg:overflow-y-auto lg:custom-scrollbar-2 lg:h-[calc(100vh-40px)] ">
            <div className="review-gallery review-modal-card w-full flex justify-center items-center lg:grow">
              {children}
            </div>
          </div>
        </div>,
        document.body
      )
    : null;
}
